RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.Queries = Backbone.Collection.extend({
        model: Admin.models.Query,
        url: '/admin/api/queries'
    });
});
